'use client';
import { Col } from '../grid';
export default Col;
